import React from 'react';
import Footer from '../components/Footer';
import GamePage from '../components/GamePage';

import BalloonsOdyssey_Tournament_Img1 from '../images/balloonsodyssey/images-16.png';


export default function BalloonsOdyssey_Tournament() {
  return (
    <>
      <GamePage
        name="Balloons Odyssey: tournament panel"
        description="Panel fully designed in Adobe Illustrator."
        images={[BalloonsOdyssey_Tournament_Img1]}
        conclusion="Already implemented in the game Balloons Odyssey."
      />
      <Footer />
    </>
  );
}